<template>
<div>
    <scroll-fixed-header :fixed.sync="fixed" :threshold="56">
    <b-navbar toggleable="lg" class="navbar-custom" type="dark">
        <b-container>
            <b-navbar-brand href="#">
                <img src="../assets/images/ayosjuan-logo.png"/>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto" v-b-scrollspy>
                    <b-nav-item href="#home" @click="scrollIntoView" active><font-awesome-icon icon="home" size="lg"  style="margin-right:10px;"/>Home</b-nav-item>
                    <b-nav-item href="#about" @click="scrollIntoView"><font-awesome-icon icon="user" size="lg"  style="margin-right:10px;"/>About</b-nav-item>
                    <b-nav-item href="#skills" @click="scrollIntoView"><font-awesome-icon icon="chart-pie" size="lg"  style="margin-right:10px;"/>Skills</b-nav-item>
                    <b-nav-item href="#portfolio" @click="scrollIntoView"><font-awesome-icon icon="briefcase" size="lg"  style="margin-right:10px;"/>Portfolio</b-nav-item>
                    <b-nav-item href="#services" @click="scrollIntoView"><font-awesome-icon icon="tools" size="lg"  style="margin-right:10px;"/>Services</b-nav-item>
                    <b-nav-item href="#contact" @click="scrollIntoView"><font-awesome-icon icon="phone" size="lg"  style="margin-right:10px;"/>Contact</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-container>
    </b-navbar>
    </scroll-fixed-header>
        <section id="home" class="bghome">
            <div class="bg-overlay"></div>
            <div>
                <b-container class="slidero">
                    <b-row>
                        <b-col lg="8" offset-lg="2" class="text-white text-center">
                            <h1 class="home-title">Let’s give your brand better exposure.</h1>
                            <p class="home-desc">Ayos Juan designs easy-to-browse interactive websites that pleases the eyes and highlights your services, interests and ideas. </p>
                        
                        </b-col>
                    </b-row>
                </b-container>
            </div> 
            <div class="d-none d-md-block">
                <vue-particles
                    color="#dedede"
                    :particleOpacity="0.7"
                    :particlesNumber="70"
                    shapeType="circle"
                    :particleSize="4"
                    linesColor="#dedede"
                    :linesWidth="1"
                    :lineLinked="true"
                    :lineOpacity="0.7"
                    :linesDistance="150"
                    :moveSpeed="4"
                    :hoverEffect="true"
                    hoverMode="repulse"
                    :clickEffect="true"
                    clickMode="push"
                >
                </vue-particles>
            </div>
        </section>
        <section id="about" class="aboutme">
            <b-container>
                <b-row>
                    <b-col lg="8" offset-lg="2">
                        <div class="iconanimate">
                        <font-awesome-icon icon="user" fixed-width  /> 
                        </div>
                        <h1>ABOUT ME
                            <p>Some information about AyosJuan and the owner.</p>
                        </h1>
                        
                    </b-col>
                </b-row>
                <div class="aboutcon">
                    <b-row>
                    <b-col lg="4">
                        <b-img src="../assets/images/dp.jpg" fluid class="shadow mt-3 rounded"></b-img>
                    </b-col>
                    <b-col lg="8">
                        <div class="text-left">
                            <h2>Let’s give your brand better exposure.</h2>
                        <p>Ayos Juan designs easy-to-browse interactive websites that pleases the eyes and highlights your services, interests and ideas. Now, you can penetrate the industry at a global scale by opening your business to the World Wide Web, making it available for everyone, from anywhere, at any time.</p> 
                            <p>Bryan the founder of AyosJuan, is a Web Developer Specialist with background in PHP development. He’s been creating easy-to-browse and fully-integrated websites with interactive and responsive interfaces. In addition, his diverse skillset includes Wordpress, Joomla, HTML5, CSS, JQuery, and Bootstrap. Bryan specializes in creating portfolios for artists, photographers, and MUAs.</p>
                        <p> In additon to that, Bryan teams up with other passionate freelancers with years of experience in Digital Marketing, UI/UX and Graphic Design in order to cater to other needs of clients.</p>
                        <p> Don’t let your business idea get lost in today’s digital age. AyosJuan is the solution to making your business and brand known by having a professional website design.</p>
                        </div>
                    </b-col>
                </b-row>
                </div>
                
            </b-container>
        </section>
        <section id="skills" class="skills bg-web-desc wbg">
            <div class="bg-overlay2"></div>
            <b-container>
                <b-row>
                    <b-col lg="8" offset-lg="2">
                        <div class="iconanimate">
                        <font-awesome-icon icon="chart-pie" fixed-width  /> 
                        </div>
                        <h1>SKILLS
                            <p>Something about my experience and skills.</p>
                        </h1>
                    </b-col>
                </b-row>
            </b-container>
            <div class="bg-pattern-effect"><b-img src="../assets/images/bg-pattern.png" fluid alt="" style="vertical-align:bottom;"></b-img></div>
        </section>
        <section id="skillscon" class="skillscon">
            <b-container>
                <b-row align-v="center" class="mb-5 mt-5">
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'html5']" size="4x" />
                    </b-col>
                    <b-col md="4">
                    <h6 class="skilllabel text-center text-md-left">HTML5</h6>
                        <div class="progress">
                            <div class="progress-bar bg-success" role="progressbar" :style="percentval" aria-valuemin="0" aria-valuemax="100">{{winheight}}</div>
                        </div>
                    </b-col>
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'css3-alt']" size="4x" />
                    </b-col>
                    <b-col md="4">
                        <h6 class="skilllabel text-center text-md-left">CSS3</h6>
                        <div class="progress">
                            <div class="progress-bar bg-warning" role="progressbar" :style="percentval" aria-valuemin="0" aria-valuemax="100">{{winheight}}</div>
                        </div>
                    </b-col>
                </b-row>
                <b-row align-v="center" class="mb-5">
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'js-square']" size="4x" />
                    </b-col>
                    <b-col md="4">
                        <h6 class="skilllabel text-center text-md-left">JS/JQUERY</h6>
                        <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" :style="percentval2" aria-valuemin="0" aria-valuemax="100">{{winheight2}}</div>
                        </div>
                    </b-col>
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'vuejs']" size="4x" />
                    </b-col>
                    <b-col md="4">
                    <h6 class="skilllabel text-center text-md-left">Vue Js</h6>
                        <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" :style="percentval3" aria-valuemin="0" aria-valuemax="100">{{winheight3}}</div>
                        </div>
                    </b-col>
                </b-row>
                <b-row align-v="center" class="mb-5">
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'bootstrap']" size="4x" />
                    </b-col>
                    <b-col md="4">
                    <h6 class="skilllabel text-center text-md-left">Bootstrap / Vue Bootstrap</h6>
                        <div class="progress">
                            <div class="progress-bar bg-success" role="progressbar" :style="percentval4" aria-valuemin="0" aria-valuemax="100">{{winheight4}}</div>
                        </div>
                    </b-col>
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'adobe']" size="4x" />
                    </b-col>
                    <b-col md="4">
                    <h6 class="skilllabel text-center text-md-left">Photoshop</h6>
                        <div class="progress">
                            <div class="progress-bar bg-warning" role="progressbar" :style="percentval" aria-valuemin="0" aria-valuemax="100">{{winheight}}</div>
                        </div>
                    </b-col>
                </b-row>
                <b-row align-v="center" class="mb-5" id="test">
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'php']" size="3x" />
                    </b-col>
                    <b-col md="4">
                    <h6 class="skilllabel text-center text-md-left">PHP</h6>
                        <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" :style="percentval4" aria-valuemin="0" aria-valuemax="100">{{winheight4}}</div>
                        </div>
                    </b-col>
                    <b-col md="2" lg="1" offset-lg="1">
                        <font-awesome-icon :icon="['fab', 'wordpress']" size="3x" />  <font-awesome-icon :icon="['fab', 'joomla']" size="3x" />
                    </b-col>
                    <b-col md="4">
                        <h6 class="skilllabel text-center text-md-left">CMS Wordpress/Joomla</h6>
                        <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" :style="percentval4" aria-valuemin="0" aria-valuemax="100">{{winheight4}}</div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>
        <section id="portfolio" class="portfolio bg-web-desc2">
            <b-container>
                <b-row>
                    <b-col lg="8" offset-lg="2">
                        <div class="iconanimate">
                        <font-awesome-icon icon="briefcase" fixed-width  /> 
                        </div>
                        <h1>PORTFOLIO
                            <p>Have a spoon of my work.</p>
                        </h1>
                    </b-col>
                </b-row>
            </b-container>
             <div class="bg-pattern-effect"><b-img src="../assets/images/bg-pattern.png" fluid alt="" style="vertical-align:bottom;"></b-img></div>
        </section>
        <section class="portfoliocon">
            <b-container>
                <div class="tabcon">
                    <b-tabs pills card>
                        <b-tab title="ALL" active>
                            <b-card-text>
                                <b-row>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-fftp.jpg" fluid class="shadow mt-3" @click="showModal('1')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-resolutelab.jpg" fluid class="shadow mt-3" tabindex="0" @click="showModal('2')"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-claytonacres.jpg" fluid class="shadow mt-3" tabindex="0" @click="showModal('3')"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-1980web.jpg" fluid class="shadow mt-3" tabindex="0" @click="showModal('4')"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-1980-new.jpg" fluid class="shadow mt-3"  @click="showModal('5')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-2000-web.jpg" fluid class="shadow mt-3"  @click="showModal('6')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-2000bet-web.jpg" fluid class="shadow mt-3" @click="showModal('7')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-2000-mobile.jpg" fluid class="shadow mt-3" @click="showModal('8')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-aibo.jpg" fluid class="shadow mt-3" @click="showModal('9')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-ajold.jpg" fluid class="shadow mt-3" @click="showModal('10')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-design.jpg" fluid class="shadow mt-3" @click="showModal('11')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                 
                                </b-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="FREELANCE">
                            <b-card-text>
                                <b-row>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-fftp.jpg" fluid class="shadow mt-3" @click="showModal('1')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-resolutelab.jpg" fluid class="shadow mt-3" tabindex="0" @click="showModal('2')"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-claytonacres.jpg" fluid class="shadow mt-3" tabindex="0" @click="showModal('3')"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-ajold.jpg" fluid class="shadow mt-3" @click="showModal('10')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="OFFICE WORK">
                            <b-card-text>
                                <b-row>
                                     <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-1980web.jpg" fluid class="shadow mt-3" tabindex="0" @click="showModal('4')"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-1980-new.jpg" fluid class="shadow mt-3"  @click="showModal('5')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-2000-web.jpg" fluid class="shadow mt-3"  @click="showModal('6')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-2000bet-web.jpg" fluid class="shadow mt-3" @click="showModal('7')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-2000-mobile.jpg" fluid class="shadow mt-3" @click="showModal('8')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-aibo.jpg" fluid class="shadow mt-3" @click="showModal('9')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="DESIGN">
                             <b-card-text>
                                <b-row>
                                    <b-col md="4" sm="6">
                                        <div class="portlist">
                                            <b-img src="../assets/images/aj-design.jpg" fluid class="shadow mt-3" @click="showModal('11')" tabindex="0"></b-img>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                     
                </div>
            </b-container>
            
        </section>
        <section id="services" class="aboutme">
            <b-container>
                <b-row>
                    <b-col lg="8" offset-lg="2">
                        <div class="iconanimate">
                        <font-awesome-icon icon="tools"  /> 
                        </div>
                        <h1>SERVICES
                            <p>What can we do?</p>
                        </h1>
                        
                    </b-col>
                </b-row>
                <div class="servicecon">
                    <b-row>
                        <b-col lg="4" class="mt-3">
                            <div class="services-box text-center hover-effect">
                            <font-awesome-icon icon="code"/> 
                                <h4 class="pt-2">Web Development</h4>
                                <p class="pt-2 text-muted">PSD to HTML, HTML5 Website, Responsive Website such as Bootstrap Website, CMS Website such as JOOMLA and WordPress. Portfolio, Business, Blog/Magazine, Medical Websites.</p>
                            </div>
                        </b-col>
                         <b-col lg="4" class="mt-3">
                            <div class="services-box text-center hover-effect">
                                <font-awesome-icon icon="user-cog" /> 
                                <h4 class="pt-2">Web Master</h4>
                                <p class="pt-2 text-muted">Website Maintenance, Hosting and server maintenance, troubleshooting, Migration of CMS website to another hosting(Wordpress and Joomla), Optimize loading speeds and capacity, Update website content.</p>
                            </div>
                        </b-col>
                        <b-col lg="4" class="mt-3">
                            <div class="services-box text-center hover-effect">
                                <font-awesome-icon icon="share-alt"  /> 
                                <h4 class="pt-2">Digital Marketing</h4>
                                <p class="pt-2 text-muted">Facebook Pixel Tracking, Google Analytics(Advanced Event Tracking, Funnel, & Goals. Generate and Analyze Reports), Social Media Marketing. Adwords (Conversion Tracking, Remarketing Run a Campaign on Standard Search, Network and Shopping.)</p>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="4" offset-lg="2"  class="mt-5">
                            <div class="services-box text-center hover-effect">
                                <font-awesome-icon icon="object-group"  /> 
                                <h4 class="pt-2">Web Design</h4>
                                <p class="pt-2 text-muted">Web & Mobile Design, Web landing pages, Forms</p>
                            </div>
                        </b-col>
                         <b-col lg="4" class="mt-5">
                            <div class="services-box text-center hover-effect">
                                <font-awesome-icon icon="edit" /> 
                                <h4 class="pt-2">Graphic Design</h4>
                                <p class="pt-2 text-muted">Logo Design, Flyers & Brochures, Business Cards & Stationery, Photoshop Editing, Banner Ads</p>
                            </div>
                        </b-col>
                        
                    </b-row>
                </div>
                
            </b-container>
        </section>
        <section id="contact" class="skills bg-web-desc3 wbg">
            <div class="bg-overlay2"></div>
            <b-container>
                <b-row>
                    <b-col lg="8" offset-lg="2">
                        <div class="iconanimate">
                        <font-awesome-icon icon="phone" fixed-width  /> 
                        </div>
                        <h1>Contact Us
                            <p>Do you need a website or logo?</p>
                        </h1>
                    </b-col>
                </b-row>
            </b-container>
            <div class="bg-pattern-effect"><b-img src="../assets/images/bg-pattern.png" fluid alt="" style="vertical-align:bottom;"></b-img></div>
        </section>
        <section class="contactcon">
            <b-container>
                 <b-row>
                    <b-col lg="8" offset-lg="2" class="mt-5">
                        <b-form>
                            <b-form-group
                                id="input-group-1"
                                label="Email address:"
                                label-for="input-1"
                                description="We'll never share your email with anyone else."
                                class="text-left"
                            >
                                <!-- v-model="form.email" -->
                                <b-form-input
                                id="input-1"
                                type="email"
                                required
                                placeholder="Enter email"
                                class="text-left"
                                v-model="clientemail"
                                ></b-form-input>
                            </b-form-group>
                            <!-- v-model="form.name" -->
                            <b-form-group id="input-group-2" label="Your Name:" label-for="input-2" class="text-left">
                                <b-form-input
                                id="input-2"
                                required
                                placeholder="Enter name"
                                v-model="clientname"
                                ></b-form-input>
                            </b-form-group>
                            <!-- v-model="text" -->
                            <b-form-group id="input-group-2" label="Message:" label-for="input-3" class="text-left">
                                <b-form-textarea
                                    id="input-3"
                                    placeholder="Enter Message..."
                                    rows="3"
                                    max-rows="6"
                                    required
                                    v-model="clientmsg"
                                    ></b-form-textarea>
                            </b-form-group>
                            <b-button type="button" variant="primary"  @click="formSubmit">Send</b-button>
                            <b-button type="reset" variant="danger">Reset</b-button>
                        </b-form>
                    </b-col>
                 </b-row>
            </b-container>
        </section>
        <div>
             <b-modal hide-footer ref="my-modal"  centered size="lg" :title="modaltitle">
                       <div class="portimg">
                           <b-img fluid :src="modalimgsrc"></b-img>
                       </div>
                       <div v-html="viewLink" style="text-align: right; padding: 20px 0px;"></div>
            </b-modal>      
        </div>  
</div>
</template>
<script >
  export default {
    data() {
      return {
        fixed: false,
        winheight: "",
        percentval: "",
        winheight2: "",
        percentval2: "",
        winheight3: "",
        percentval3: "",
        winheight4: "",
        percentval4: "",
        modaltitle: "",
        modalimgsrc: "",
        viewLink: "",
        clientname: "",
        clientemail: "",
        clientmsg: "",
        output: ""
      }
    },

     methods: {
        formSubmit() {
                // e.preventDefault();
                let currentObj = this;
                var formdata = new FormData();
                formdata.append('clientname', currentObj.clientname)
                formdata.append('clientemail', currentObj.clientemail)
                formdata.append('clientmsg', currentObj.clientmsg)

                currentObj.$axios({
                url: 'http://www.ayosjuan.com/api/mailer.php',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                data: formdata,
                method: 'post'
                })
                .then(function (response) {
                    //currentObj.output = response.data;
                    // alert(response.data)
                    if (response.data.error) {
                        alert('Error: '+response.data.error)
                    } else {
                        // this.postStatus = true;

                       alert(response.data)
                    }
                })
                .catch(function (error) {
                    // currentObj.output = error;
                     alert(error)
                })
        }, 
        showModal(modalVal) {
            var pathimg = require.context('../assets/images', false)
            if(modalVal === "1") {
                this.modaltitle = "Foundation For the Poor Inc"
                this.modalimgsrc =pathimg('./aj-fftp.jpg')
                this.viewLink = "<a target='_blank' href='https://www.foundationforthepoorinc.org' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "2") {
                this.modaltitle = "Resolute Lab"
                this.modalimgsrc =pathimg('./aj-resolutelab.jpg')
                this.viewLink = "<a target='_blank' href='https://www.resolutelab.com' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "3") {
                this.modaltitle = "Clayton Acress B&B"
                this.modalimgsrc =pathimg('./aj-claytonacres.jpg')
                this.viewLink = "<a target='_blank' href='http://www.claytonacres.com' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "4") {
                this.modaltitle = "1980 Web"
                this.modalimgsrc =pathimg('./aj-1980web.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/1980/Web/' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "5") {
                this.modaltitle = "1980 Mobile"
                this.modalimgsrc =pathimg('./aj-1980-new.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/1980/Mobile/' class='btn btn-success' style='margin-right:10px;'>Demo Index</a><a target='_blank' href='http://www.ayosjuan.com/1980/Mobile/account.html' class='btn btn-success'>Demo Account</a>"
            }
            else if(modalVal === "6") {
                this.modaltitle = "2000 Web"
                this.modalimgsrc =pathimg('./aj-2000-web.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/2000/Web/' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "7") {
                this.modaltitle = "2000 Betting Web"
                this.modalimgsrc =pathimg('./aj-2000bet-web.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/2000/Web/betting.html' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "8") {
                this.modaltitle = "2000 Betting Mobile"
                this.modalimgsrc =pathimg('./aj-2000-mobile.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/2000/Mobile/index.html' class='btn btn-success'  style='margin-right:10px;'>Demo index</a><a target='_blank' href='http://www.ayosjuan.com/2000/Mobile/betting.html' class='btn btn-success'  style='margin-right:10px;'>Demo Bet</a><a target='_blank' href='http://www.ayosjuan.com/2000/Mobile/account.html' class='btn btn-success'>Demo Account</a>"
            }
            else if(modalVal === "9") {
                this.modaltitle = "Aibo (VueJs Sample)"
                this.modalimgsrc =pathimg('./aj-aibo.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/vuesample/' class='btn btn-success'>View Site</a>"
            }
            else if(modalVal === "10") {
                this.modaltitle = "AyosJuan Old Website"
                this.modalimgsrc =pathimg('./aj-ajold.jpg')
                this.viewLink = "<a target='_blank' href='http://www.ayosjuan.com/ajold/' class='btn btn-success'>View Site</a>"
            }
             else if(modalVal === "11") {
                this.modaltitle = "Logo Design"
                this.modalimgsrc =pathimg('./aj-design.jpg')
                this.viewLink = ""
            }
             this.$refs['my-modal'].show()
        },
         scrollIntoView(evt) {
            evt.preventDefault()
            const href = evt.target.getAttribute('href')
            const el = href ? document.querySelector(href) : null
            if (el) {
              //window.scrollTo(0, el.offsetTop);
              window.scrollTo({ top: el.offsetTop, behavior: 'smooth' })
            }
        },
        handleScroll () {
         var condiv = this.$el.querySelector("#skills");
            // var windowheight = window.pageYOffset + window.innerHeight;
            // var conres = condiv.offsetTop + condiv.offsetHeight;
            var conres = condiv.offsetTop + condiv.offsetHeight - window.innerHeight;
      
           
            //  if  (condiv.offsetTop >= window.pageYOffset && conres <= windowheight)  {
                if  (window.pageYOffset-condiv.offsetHeight >= conres)  {
                this.winheight = "90%";
                this.percentval = "width: 90%";
                this.winheight2 = "75%";
                this.percentval2 = "width: 75%";
                this.winheight3 = "50%";
                this.percentval3 = "width: 50%";
                this.winheight4 = "80%";
                this.percentval4 = "width: 80%";
             }
          
          
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
      
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>   
<style lang="scss">
.scroll-fixed-header {
    position: absolute;
    width: 100%;
}
.navbar-custom {
    padding: 20px 0px;
    width: 100%;
    border-radius: 0px;
    z-index: 999;
    margin-bottom: 0px;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    .navbar-brand {
        text-transform: uppercase;
        color: #fff !important;
        font-weight: 700;
        letter-spacing: 2px;
        height: auto;
        font-family: 'Poppins', sans-serif;
            
        img { width: 200px; }
    }
    .navbar-nav {
        margin-left: 50px;
        border-bottom: none;
            li a {
                color: rgba(255, 255, 255, 0.6);
                font-size: 15px;
                background-color: transparent !important;
                padding: 15px 0;
                margin: 0 10px;
                transition: all 0.4s;

                svg {
                    position: relative;
                    z-index: -1;
                }
            }
        li a:hover,
        li a:focus,
        li a:active {
            color: #fff;
            }
        li.active a {
            color: #fff;
            } 
    }
    .btn-custom {
        margin-top: 4px;
        margin-bottom: 4px;
    }
    
}


.is-fixed .navbar-custom {
    margin-top: 0px;
    padding: 10px 0px;
    background-color: #000000;
    -moz-box-shadow: 0 10px 33px rgba(0, 0, 0, .5);
    -webkit-box-shadow: 0 10px 33px rgba(0, 0, 0, .5);
    box-shadow: 0 10px 33px rgba(0, 0, 0, .5);
}

.navbar-toggle {
    font-size: 24px;
    margin-top: 0px;
    margin-bottom: 0px;
    color: #ffffff;
}

.nav .open>a,
.nav .open>a:focus,
.nav .open>a:hover {
    background-color: transparent;
    border-color: #337ab7;
}


/*---Navbar-White--*/

.navbar-custom.navbar-white {
    background-color: #fff;
    padding: 10px 0;
    box-shadow: 0 10px 33px rgba(0, 0, 0, .1);
}

.navbar-custom.navbar-white .navbar-nav li a,
.navbar-custom.navbar-white .navbar-brand,
.navbar-white .navbar-toggle {
    color: #393f4f !important;
}
section {
    padding-top: 30px;
    padding-bottom: 80px;
    position: relative;
    h1 { color:#333; position: relative; padding-bottom: 20px; margin-bottom: 50px;
        p {
            font-size: 16px;
            margin-top: 10px;
        }
    }

}
.bghome {
    background: url(../assets/images/bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100vh;
    padding-bottom: 0px;
    padding-top: 80px;
    overflow: hidden;
    .bg-overlay {
        // background: linear-gradient(to right, #512DA8, #711e72);
        background: linear-gradient(to right, #464343, #000000);
        opacity: 0.7;
        position: absolute;
        height: 100%;
        width: 100%;
        right: 0;
        bottom: 0;
        left: 0;
        top: 0;
    }
    .home-desc {
        font-size: 20px;
    }
}
.slidero {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    z-index: 100;
    left: 0;
    right: 0;
}
#particles-js { position: relative; }
.section-title-border, .services-box:hover i, .bg-custom, .btn-custom, .features-item-list li:before, .process-left-icon-1 i, .process-left-icon-2 i {
    background-color: #fb3e3e;
}
.iconanimate {
    background: #9d0b0e;
    border-radius: 50%;
    color: #fff;
    display: block;
    font-size: 25px;
    height: 60px;
    line-height: 60px;
    margin: auto auto 10px;
    text-align: center;
    box-shadow: 0 0 0 0 rgba(157, 11, 14, 0.5);
    width: 60px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    margin-top: 50px;
    margin-bottom: 50px;
}

section:hover .iconanimate {
    box-shadow: 0 0 0 50px rgba(256, 256, 256, 0);
}
.bghome h1:before, .bghome h1:after{
    display: none;
}
.bghome h1 { color:#fff; position: relative; padding-bottom: 20px; margin-bottom: 0px;}
section h1:before{
    position: absolute;
    left: 50%;
    bottom: 0;
    height: 2px;
    width: 100px;
    content: "";
    background: #9d0b0e;
    margin-left: -50px;
}
section h1:after {
    position: absolute;
    left: 50%;
    bottom: -4px;
    height: 10px;
    width: 10px;
    content: "";
    background: #9d0b0e;
    margin-left: -5px;
    border-radius: 50%;
}
.wbg {
    .iconanimate {
    background:rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 0 0 rgba(256, 256, 256, 0.5);
    }
    h1 { color: #fff;}
     h1:before, h1:after{
         background: #fff;
     }
}
.portfolio {
    background: #efefef;
    padding: 20px 0px 40px 0px;
    .iconanimate {
        background: #001447;
        box-shadow: 0 0 0 0 rgba(0, 20, 71, 0.5);
    }
    h1:before, h1:after{
        background: #001447;
    }
}
.portlist {
    margin-bottom: 20px;
    cursor: pointer;
    .rounded {
        border-radius: .7rem!important;
    }
    .shadow {
        -webkit-box-shadow: 0 .5rem 1rem rgba(0,0,0,.25)!important;
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.25)!important;
    }
     img {
         outline: none;
    // border-radius: 10px;
    // -webkit-box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.5);
    // -moz-box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.5);
    // box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.5);
     }
}
.tabcon {
     a { color:#333; }
     .card-header { background: transparent}
}
.bg-web-desc {
    background: url(../assets/images/skillsbg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
}
.bg-web-desc2 {
    background: url(../assets/images/portfolio.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    background-attachment: fixed;
}
.bg-web-desc3 {
    background: url(../assets/images/contactbg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    background-attachment: fixed;
}
.bg-overlay2 {
    background: linear-gradient(to right, #001447, #f79f00, #9d0b0e);
    opacity: 0.9;
    position: absolute;
    height: 100%;
    width: 100%;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
}
.bg-pattern-effect {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
}
.progress {
     background-color: #cecece;
 
}
.progress-bar {
     width: 0%;
//   transition: width .6s ease;
 }
.portimg { 
    width: 80%;
    margin: 0px auto;
}
.servicecon svg {
    font-size: 40px;
    margin-bottom: 20px;
    color: #737373;
    margin-top: 20px;
}
.hover-effect {
    transition: all .3s ease-in-out;
}
.hover-effect:hover {
    transform: translateY(-1rem);
}
.hover-effect:hover svg{
    color:#9d0b0e;

}
.hover-effect:hover h4{
    color: #ffc107;
}
.hover-effect:hover p{
    color: #001447 !important;
}
.contactcon button { margin: 10px; }
@media screen and (max-width: 768px) {
    .navbar-custom .container { max-width: 100%; }
     .navbar-custom .navbar-brand img {  padding-left: 10px; }
      .navbar-dark .navbar-toggler {
        margin-right: 10px;
    }
    .navbar-collapse {
        background: #000;
        z-index: -2;
    }
}
@media screen and (max-width: 767px) {
    
    .navbar-custom .navbar-brand img {
        width: 150px;
    }
   
}
</style>